module.exports = __webpack_public_path__ + "static/media/no-item.0da7d644.svg";